import { IMAGE_MOBILE, IMAGE_DESKTOP } from '../elements/assets'
import { LINK_TITLE } from '../elements/link'

export const CARD_WITH_VIDEO = `
...on cardWithVideo_Entry {
  id
  typeHandle

  headingAdvanced {
    html
  }
  description
  textPosition

  cardText {
    html
  }

  imageTextMatrix {
   typeHandle
    image {
      url
    }
    title
    text
    description

    iconField { url }
    ${ LINK_TITLE }
  }

  ${ IMAGE_MOBILE }
  ${ IMAGE_DESKTOP }

  videoUrl {
    url
  }
}
`